/**=========================================================
 * Module: main.js
 * Main Application Controller
 =========================================================*/

App.controller('appController', ( $rootScope, $api, $scope, $state, $window, $localStorage, $location, $cookies, toggleStateService, authService, colors, browser, ngDialog, responseHelper, SERVER_BASE_URL, USER_TYPES, Appointment, Perm, toaster, ChromeExtension, FeatureFlag, a2pBranding, a2pTelnyxBrand) => {
  $rootScope.showA2pBanner = false;
  $rootScope.embedded = $location.search().embedded === 'true'
  if ($rootScope.embedded) {
    $rootScope.embedded_location_id = $location.search().location_id
    $rootScope.embedded_subdomain = $location.search().subdomain
    $rootScope.embedded_auth_token = $cookies.get('dev_portal_auth_token')
    $rootScope.embedded_show_requestable = $location.search().show_requestable === 'true'
  }

    $scope.saas_react_templates = false
    FeatureFlag.$find('saas_react_templates').$then((ff) => {
      $scope.saas_react_templates = ff.saas_react_templates
    })

    // Templates states whose React port has landed. The port ships one page at a
    // time, so a state joins this list in the same PR that ports it: while the
    // flag is on, listed states render the React page and the rest keep serving
    // the Angular views. Settings is never ported, and the schedule editor states
    // already hand off to React on their own.
    const PORTED_TEMPLATE_STATES = [
      'app.campaigns_templates.default',
      'app.campaigns_templates.custom'
    ]

    $scope.showMigratedPages = () => {
      if (PORTED_TEMPLATE_STATES.includes($state.current.name)) {
        return $scope.saas_react_templates
      }

      switch($state.current.name) {
        case 'app.online_booking_dashboard.patients':
          return true
        default:
          return false
      }
    }

    Perm.getConnections()
    Perm.perm_promise.then( () => {
      $scope.redirectHomeIfOnDashboard()
      $scope.setShowOldFormsUI()

      // We don't display a2pBanner in the embedded mode, so we can skip this call
      if (!$rootScope.embedded) {
        if ($rootScope.institution.messaging_provider === 'twilio') {
          a2pBranding.$find().then((response) => {
            maybeShowA2pBanner(response, 'data.data.a2p_brand_registration.status')
          })
        } else if ($rootScope.institution.messaging_provider === 'telnyx') {
          a2pTelnyxBrand.$find().then((response) => {
            maybeShowA2pBanner(response, 'data.data.status')
          })
        }
      }

      if($rootScope.institution) {
        $scope.contentClass = getContentClass();
      }

      authService.registerHeap()

      window.Sentry && Sentry.setUser({
        institution_id: $rootScope.institution && $rootScope.institution.id,
        id: $rootScope.user && $rootScope.user.id,
        user_type: $rootScope.user && $rootScope.user.meta_type
      });


      // this block may need some double-checking
      if(!$rootScope.user || $rootScope.user.meta_type == 'Patient'){
        toaster.pop('success', 'Success', "You've been automatically logged out - please log back in to continue.")
        lg("Logging out...")
        $rootScope.logOut()
      }

      lg("Initializing provider app...")
      ChromeExtension.checkInstallation($scope)
    })

    const maybeShowA2pBanner = (response, brand_status_field) => {
      if ($rootScope.institution) {
        $rootScope.showA2pBanner = $rootScope.institution.show_a2p_banner
        if (
          _.get(response, brand_status_field) === 'failed' && $rootScope.institution.is_client_live
        ) {
          $rootScope.isNewCustomer = false
          $rootScope.a2pRegistrationFailed = true
        } else {
          $rootScope.isNewCustomer = moment(
            $rootScope.institution.created_at
          ).isAfter(moment().subtract(12, 'days'))
          $rootScope.a2pRegistrationFailed = false
        }
      }
    }

    const getContentClass = () => {
      // errors without this
      if(!$rootScope.institution) return 'content-wrapper';

      const impersonating = $rootScope.impersonationSessionId || $rootScope.impersonated
      if((impersonating && !$rootScope.showA2pBanner) || (!impersonating && $rootScope.showA2pBanner)) {
        return 'content-wrapper-below'
      } else if (impersonating && $rootScope.showA2pBanner) {
        return 'content-wrapper-below-below'
      } else {
        return 'content-wrapper'
      }
    }

    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
        event.targetScope.$watch("$viewContentLoaded", () => {
          ChromeExtension.checkInstallation($scope)
        })
    })

    $rootScope.$watch('showA2pBanner', () => {
      $scope.contentClass = getContentClass()
    })


    // Hook not found
    $rootScope.$on('$stateNotFound',
      (event, unfoundState, fromState, fromParams) => {
      })
    // Hook error
    $rootScope.$on('$stateChangeError',
      (event, toState, toParams, fromState, fromParams, error) => {
      })

    // iPad may presents ghost click issues
    // if( ! browser.ipad )
    // FastClick.attach(document.body)

    // Restore layout settings
    if( angular.isDefined($localStorage.layout) )
      $scope.app.layout = $localStorage.layout
    else
      $localStorage.layout = $scope.app.layout

    $rootScope.$watch("app.layout", () => {
      $localStorage.layout = $scope.app.layout
    }, true)

    $scope.toggleUserBlock = () => {
      $scope.$broadcast('toggleUserBlock')
    }

    // notification catchers
    $scope.$on('notifModal', (angev,data) => {
       switch(data.modal){
            case 'appt_details':
              $scope.appt_details(data.params)
              break;
            default:

       }
    })

    // Allows to use branding color with interpolation
    // {{ colorByName('primary') }}
    $scope.colorByName = colors.byName

    // Surveys
    $scope.viewSurvey = function (survey) {
        $scope.modal = ngDialog.open({
            controller: "showSurveyModalCtrl",
            template: 'app/views/surveys/partials/form-provider.html',
            data: {survey: survey},
            appendClassName: 'ne__modal ne__modal--survey-provider'
        })
    }

    // Restore application classes state
    toggleStateService.restoreState( $(document.body) )

    // cancel click event easily
    $rootScope.cancel = $event => {
      $event.stopPropagation()
    }


    $scope.isStaff = authService.isStaffOrNurse()
    $scope.isProvider = authService.isProvider()
    $scope.userIsProvider = u => {
      return USER_TYPES.provider_types.indexOf(u.meta_type) != -1
    }
    $scope.userIsStaff = u => {
      return USER_TYPES.staff_types.indexOf(u.meta_type) != -1
    }
    $scope.redirectHomeIfOnDashboard = () => {
      if($state.current.name === "app.activities") {
        $state.go('app.home')
      }
    }

    $scope.setShowOldFormsUI = () => {
      $rootScope.showOldFormsUI = !$rootScope.location.enlive_enabled
    }

    $rootScope.showOldNavigation = false

    $scope.$on('loc_change', $scope.setFormsInNavbar)

    $scope.$on('loc_change', $scope.redirectHomeIfOnDashboard)

    $scope.$on('loc_change', $scope.setShowOldFormsUI)

    $scope.appt_details = (calEvent, $event) => {
      if ($event && $event.target && $($event.target).parents('.ne__dropdown#stop_propagation').length) {
        // prevent appt details popup showing on click inside dropdown with #stop_propagation id (e.g Appt reminder - Opt out)
        return
      }
      if(!calEvent || !calEvent.uuid || (calEvent.type && calEvent.type.length && calEvent.type != 'Appointment')) {
        return
      }
      const putAppointment = Appointment.$find(calEvent.uuid)
      putAppointment.$then((appt) => {
        var dialog = ngDialog.open({
          template: '/app/views/modal/appt/appt-details.html',
          data: {appt},
          controller: 'apptDetailCtrl',
          className: 'ne__modal ne__modal--appt'
        })
      })
    }

    // HEADER/NAVBAR/SIDEBAR
    // HEADER/NAVBAR/SIDEBAR
    // HEADER/NAVBAR/SIDEBAR


    $scope.liuname = authService.getUserAuthorization().name
    $scope.liuimage = authService.getUserImageUrl()
    $scope.notHeading = function(i){
      return i.heading != true
    }

    $scope.userfns = [
      {
         name: "Settings",
         desc: "Change your settings",
         route: "app.settings.personal",
         subroutes: []
       },{
         name: "Log out",
         desc: "Log out of your session",
         click: $scope.logOut
       }
    ]

    Perm.perm_promise.then( () => {
      $scope.redirectUnlessCanAccessTab = (user_permission, inst_privilege = false, is_patient_tab = false) => {
        if(!Perm.can_access_tab(user_permission, inst_privilege)) {
          if (is_patient_tab) {
            redirectionPath = 'app.patient'
          } else {
            redirectionPath = 'app.home'
          }
          $state.go(redirectionPath)
        }
      }
      $scope.navbar = []
      if (Perm.can_access_tab('messages')) {
        $scope.navbar.push({
          name: "Messages",
          desc: "Conversations with your patients",
          route: "app.messages",
          subroutes: ["app.messages.message"]
        })
      }
      if (Perm.can_access_tab('online_booking')) {
        $scope.navbar.push({
          name: "Online Booking",
          desc: "Browse online booking related info, and setup",
          route: "app.online_booking_dashboard.patients",
          subroutes: []
        })
      }
      if (Perm.can_access_tab('patients')) {
        $scope.navbar.push({
          name: "Patients",
          desc: "Browse your patients",
          route: "app.patients.patients",
          subroutes: ['app.patient', 'app.patients.unsubscribe']
        })
      }
      if (Perm.can_access_tab('payments', 'is_payments_tab_activated')) {
        $scope.navbar.push({
          name: "Payments",
          desc: "Request payments",
          route: "app.payments.request-payment",
          subroutes: ["app.payments.patients", "app.payments.online-widget"]
        })
      }
      if (Perm.can_access_tab('calendar')) {
        $scope.navbar.push({
          name: "Calendar",
          desc: "Browse your appointments on a calendar",
          route: "app.calendar",
          subroutes: []
        })
      }
      if (Perm.can_access_tab('waitlist')) {
        $scope.navbar.push({
          name: "Waitlist",
          desc: "Fill appointment slot for patients in queue",
          route: "app.appointment-slots-waitlist",
          subroutes: []
        })
      }
      if (Perm.can_access_tab('templates')) {
        $scope.navbar.push({
          name: "Templates",
          desc: "Templates Campaigns: Reminders, Recalls, Reviews, Birthday, Missed, Cancelled, Appointment Request, Appointment Confirmed, Appointment Rescheduled, New Patient, New PMS Appointment, Payments, Waitlist Appointment, Waitlist Continuing Care",
          route: "app.campaigns_templates.default",
          subroutes: ["app.campaigns_templates.custom", "app.campaign_template"]
        })
      }
      if (Perm.can_access_tab('campaigns')) {
        $scope.navbar.push({
          name: "Campaigns",
          desc: "Manual Email and SMS Campaigns",
          route: "app.campaigns_manuals",
          subroutes: ["app.campaign_manual"]
        })
      }
      if (Perm.can_access_tab('form_responses')) {
        $scope.navbar.push({
          name: 'Forms',
          desc: 'Form responses from patients',
          route: 'app.enlive',
          subroutes: [],
          show_when_enlive_enabled: true
        })

        $scope.navbar.push({
          name: 'Forms',
          desc: 'Form responses from patients',
          route: 'app.form-responses',
          subroutes: [],
          hide_when_enlive_enabled: true
        })
      }
      if (Perm.can_access_tab('analytics')) {
        $scope.navbar.push({
          name: "Analytics",
          desc: "Analytics for your organization",
          route: "app.analytics",
          subroutes: []
        })
      }
      if (Perm.can_access_tab('setup') || Perm.can_access_tab('availability')) {
        $scope.navbar.push({
          name: "Setup",
          desc: "Setup information related to online booking",
          route: "app.setup.availability",
          subroutes: [
            "app.setup.logo",
            "app.setup.insurances",
            "app.setup.online_booking_form",
            "app.setup.appointment_types",
            "app.setup.appointment_type_mappings"
          ]
        })
      }
      $scope.navbar.push({
        name: "Refer a Practice",
        desc: "Refer another practice link",
        route: "app.refer_a_practice",
        subroutes: [],
        external_url: 'https://www.nexhealth.com/resources/submit-a-referral',
        target: "_blank"
      })

      $scope.$watch(() => $state.current.name, (nv,ov) => {
        // lg("new state",nv)
          _.each($scope.navbar, r => {
            r.active = (
              r.route == nv ||
              nv.indexOf(r.route) != -1 ||
              (r.subroutes && (
                r.subroutes.indexOf(nv) != -1 ||
                _.some(r.subroutes, sr => (nv.indexOf(sr) != -1))
              ))
            )
          })
      })
    })


    $scope.srefNav = item => {
      if(item.route){
        $state.go(item.route)
      } else {
        item.click()
      }
    }


})
